<div class=" row m-auto" style="    ">
    <div class="col-md-6 col-sm-12">

        <app-ad-card [image]="'assets/modern_light.png'" [bg_color]="'#c8a988'"
                     [price]="4.246" [title]="'modern_lights'|translate"
                     [link]="'/web/home/product/browser/1202'"
                     [subheading]="'for_a_modern_life'|translate"></app-ad-card>


    </div>
    <div class="col-md-6 col-sm-12">

        <img  [routerLink]="'categories/1235'" class="img-fluid mt-4 mt-sm-4 mt-md-0" src="assets/cards/frontpage-camera-box_{{lang}}.jpg">
<!--        <app-ad-card [image-space]="5" [image]="'assets/future_light.jpeg'"-->
<!--                     [link]="'/product/details/byk/lp-7145w/010403010203100401'"-->
<!--                     [bg_color]="'rgb(171 170 169)'" [price]="4.34" [title]="'future_lights'|translate" [subheading]="'smart_compact'|translate"></app-ad-card>-->

    </div>

</div>

<!--/web/home/categories/1134-->
